import useSnapshot from "./useSnapshot";

export default function useDocumentOnce(query) {
	return useSnapshot(query, false);
}
